export default __webpack_public_path__ + "static/media/replay.b19d5abc.svg";